

export class RatesModel {
    bch: any = 0;
    liveRate: any = 0;
    btc: any = 0;
    // added support for BNB live rate coming from API response
    bnb: any = 0;
    btg: any = 0;
    dash: any = 0;
    eth: any = 0;
    ltc: any = 0;
    neo: any = 0;
    bonus: any = 0;
    mxn: any = 0;
    fru: any = 0;
    usd: any = 0;
    baseRate: any = 0;
    stageName: any = '';
    // added support for TRX (Tron) live rate coming from API response
    trx: any = 0;
    // mxnp: any = 0;
}
